// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__26ghG","header":"MessagesList_header__3JhLm","chat":"MessagesList_chat__PWbmy"};